import React, {useState, useEffect} from 'react';
import {Bar, Column, Line, Liquid} from '@ant-design/plots';
import {Button, DatePicker, Modal, Select} from "antd";
import dayjs from "dayjs";
import moment from "moment/moment";
import {API_PATH} from "../../components/const";
import axios from "axios";
import {toast} from "react-toastify";
import LiquidChart from "./LiquidChart";

const {RangePicker} = DatePicker;
const dateFormat = 'YYYY-MM-DD';
const WorkingTime = () => {
    const [data, setData] = useState([]);
    const [time, setTime] = useState(new Date());
    const [offices, setOffices] = useState([])
    const [selectOffices, setSelectOffices] = useState(null)
    const [firstDay, setFirst] = useState("")
    const [year, setYear] = useState("")
    const [month, setMonth] = useState("")
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [employeeList, setEmployeeList] = useState([])
    const [graphData, setGraphData] = useState([])
    const [parents, setParents] = useState([])




    const getParentBuilding = (val) => {
        axios.get(API_PATH + "company/" + localStorage.getItem('id') + "/branch/sections/all" + (val?.length > 0 ? "?search_str=" + val : ""), {headers: {"Authorization": 			"Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setParents(res?.data)
            })
            .catch(err => {
                toast.error("Ошибка")
            })
    }
    const getBuilding = (val) => {

        axios.get(API_PATH + "company/" + localStorage.getItem('id') + "/branch/branch/all?hierarchy=3" + (val > 0 ? "&parent_id=" + val : ""), {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setOffices(res?.data)
                setSelectOffices(res?.data[0]?.id)
                if (res?.data?.items?.length > 0) {
                    axios.get(API_PATH + "deepstream/company/" + localStorage.getItem('id') + "/ds_analytics/employee/workplace-analysis?date_str=" + time?.getFullYear() + "-" + Number(time?.getMonth() + 1) + "-" + time?.getDate() + "&branch_id=" + (selectOffices !== null ? selectOffices : res?.data?.items[0]?.id), {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
                        .then((res2) => setGraphData(res2?.data?.map(item => {
                            return {
                                ...item,
                                value: Math.floor(item?.totalDurationInMinutes ? item?.totalDurationInMinutes : 0),
                                name: item?.username,
                                type: item?.type,
                            }
                        })))
                    axios.get(API_PATH + "deepstream/company/" + localStorage.getItem('id') + "/ds_analytics/employee/workload-analysis?date_str=" + time?.getFullYear() + "-" + Number(time?.getMonth() + 1) + "-" + time?.getDate() + "&branch_id=" + (selectOffices !== null ? selectOffices : res?.data?.items[0]?.id), {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
                        .then(res => {
                            // console.log(res?.data)
                            setEmployeeList(res?.data)
                        })
                }
            })
            .catch(err => {
                toast.error("Ошибка")
            })
    }

    function onChange(date, dateString) {
        if (dateString !== "") {
            axios.get(API_PATH + "deepstream/company/" + localStorage.getItem('id') + "/ds_analytics/employee/workplace-analysis?date_str=" + dateString + "&branch_id=" + selectOffices, {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
                .then((res2) => {
                    setGraphData(res2?.data?.map(item => {
                        return {
                            ...item,
                            value: Math.floor(item?.totalDurationInMinutes ? item?.totalDurationInMinutes : 0),
                            name: item?.username,
                            type: item?.type,
                        }
                    }))
                })
            axios.get(API_PATH + "deepstream/company/" + localStorage.getItem('id') + "/ds_analytics/employee/workload-analysis?date_str=" + dateString + "&branch_id=" + selectOffices, {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
                .then(res => {
                    setEmployeeList(res?.data)
                })
            setFirst(dateString)
        } else {

            getEmployee()
            axios.get(API_PATH + "deepstream/company/" + localStorage.getItem('id') + "/ds_analytics/employee/workplace-analysis?date_str=" + time?.getFullYear() + "-" + Number(time?.getMonth() + 1) + "-" + time?.getDate() + "&branch_id=" + selectOffices, {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
                .then((res2) => setGraphData(res2?.data?.map(item => {
                    return {
                        ...item,
                        value: Math.floor(item?.totalDurationInMinutes ? item?.totalDurationInMinutes : 0),
                        name: item?.username,
                        type: item?.type,
                    }
                })))
        }
    }

    const onChangeBuild = (e) => {
        setSelectOffices(e)

        axios.get(API_PATH + "deepstream/company/" + localStorage.getItem('id') + "/ds_analytics/employee/workplace-analysis?date_str=" + firstDay + "&branch_id=" + e, {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then((res2) => setGraphData(res2?.data?.map(item => {
                return {
                    ...item,
                    value: Math.floor(item?.totalDurationInMinutes ? item?.totalDurationInMinutes : 0),
                    name: item?.username,
                    type: item?.type,
                }
            })))
        axios.get(API_PATH + "deepstream/company/" + localStorage.getItem('id') + "/ds_analytics/employee/workload-analysis?date_str=" + firstDay + "&branch_id=" + e, {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setEmployeeList(res?.data)
            })

    }

    function convertMinutesToHoursAndMinutesString(minutes) {
        let hours = Math.floor(minutes / 60);
        let remainingMinutes = minutes % 60;
        let result = hours !== 0 ? hours + " hours " : "";
        if (remainingMinutes !== 0) {
            result += remainingMinutes + " minutes";
        }
        return result;
    }
    const getEmployee = () => {
        axios.get(API_PATH + "deepstream/company/" + localStorage.getItem('id') + "/ds_analytics/employee/workload-analysis?date_str=" + time?.getFullYear() + "-" + Number(time?.getMonth() + 1) + "-" + time?.getDate() + "&branch_id=" + selectOffices, {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setEmployeeList(res?.data)
            })
    }
    const getGraph = (e) => {
        axios.get(API_PATH + "deepstream/company/" + localStorage.getItem('id') + "/ds_analytics/employee/monthly-workload-analysis/" + e + "?year=" + year + "&month=" + month, {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setData(res?.data)
                setIsModalOpen(true)

            })
    }
    const configBar = {
        data: graphData,
        isStack: true,
        xField: 'value',
        yField: 'name',
        seriesField: 'type',
        colorField: 'type',
        color: ['#5664D2', '#EB5757', '#F59638'],
        label: {
            position: 'middle',
            layout: [
                {
                    type: 'interval-adjust-position',
                },
                {
                    type: 'interval-hide-overlap',
                },
                {
                    type: 'adjust-color',
                },
            ],
            content: (originData) => {
                const val = parseFloat(originData.value);

                if (val !== 0) {
                    return convertMinutesToHoursAndMinutesString(val);
                }
            },
            offset: 10,
        },

    };
    // const config = {
    //     graphData,
    //     xField: 'date' ,
    //     yField: 'workload',
    //     legend: {
    //         position: 'top',
    //     },
    //     color:['#FC53F5', '#5664D2', '#00E480', '#FF3542', '#0090EB', '#FFB100', '#4D4F6C'],
    //
    //     smooth: true,
    //     animation: {
    //         appear: {
    //             animation: 'path-in',
    //             duration: 5000,
    //         },
    //     },
    // };
    const config = {
        data,
        smooth: true,
        padding: 'auto',
        xField: 'date',
        yField: 'workload',
        xAxis: {
            // type: 'timeCat',
            tickCount: 5,
        },
    };

    useEffect(() => {
        setFirst(time?.getFullYear() + "-" + Number(time?.getMonth() + 1) + "-" + time?.getDate())
        setMonth(Number(time?.getMonth() + 1))
        setYear(time?.getFullYear() )
        getBuilding()
        getParentBuilding()
    }, [])
    return (
        <div className="visitor visitor-box ">
            <div className="chart-box mb-3  ">

                <div className="visitor-title mb-5">

                    <div className="d-flex justify-content-between mb-4">
                        <div className="d-flex align-items-center">
                            <h1 className="m-0">
                                <span>
                                 Working time
                                   </span>
                            </h1>

                        </div>

                    </div>
                    <div>
                        <div className="d-flex">
                            <div className="d-flex flex-column mr-16">
                                <label className="text-white mb-2">Раздел</label>
                                <Select
                                    showSearch
                                    placeholder="Выберите раздел"
                                    optionFilterProp="children"
                                    style={{width: "200px"}}
                                    onSearch={getParentBuilding}
                                    onChange={(e) => getBuilding(e)}
                                    filterOption={(input, option) => (option?.label ?? '').includes(input)}
                                    filterSort={(optionA, optionB) =>
                                        (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                                    }
                                    options={parents?.map((item) => {
                                        return {
                                            value: item.id,
                                            label:
                                            item?.branch_title
                                        };
                                    })}
                                />
                            </div>
                            <div className="d-flex flex-column">
                                <label className="text-white mb-2">Филиал</label>
                                <Select
                                    showSearch
                                    style={{width: "200px"}}
                                    placeholder="Выберите филиал"
                                    optionFilterProp="children"
                                    className="mr-24  "
                                    value={selectOffices}
                                    onSearch={getBuilding}
                                    onChange={(e) => onChangeBuild(e)}
                                    // onChange={(e) => setCountry(e)}
                                    filterOption={(input, option) => (option?.label ?? '').includes(input)}
                                    filterSort={(optionA, optionB) =>
                                        (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                                    }
                                    options={offices?.map((item) => {
                                        return {
                                            value: item.id,
                                            label:
                                            item?.branch_title
                                        };
                                    })}
                                />
                            </div>
                            <div className="d-flex flex-column">
                                <label className="text-white mb-2">Выберите дату</label>
                                {/*<RangePicker*/}
                                {/* placeholder={["Дата начала", "Дата окончания"]}*/}
                                {/*     defaultValue={[dayjs(moment().startOf('month').format('YYYY-MM-DD'), dateFormat), dayjs(moment().endOf('month').format('YYYY-MM-DD'), dateFormat)]}*/}

                                {/*     format={dateFormat}*/}
                                {/*     onChange={onChange}*/}
                                {/* />*/}
                                <DatePicker
                                    placeholder="Выберите дату"
                                    format={dateFormat}
                                    defaultValue={dayjs(moment().format('YYYY-MM-DD'))}
                                    style={{width: "260px"}}
                                    onChange={onChange}/>
                            </div>
                        </div>

                    </div>
                </div>
                <Bar {...configBar} />
            </div>
            <div className="work-time-box-list">
                <div className="row">
                    {
                        employeeList?.map((item, index) => (
                            <LiquidChart getGraph={getGraph}
                                         setIsModalOpen={setIsModalOpen}
                                         data={item}/>
                        ))
                    }
                </div>
            </div>
            {
                isModalOpen
                ?
                    <Modal title="Загруженность"
                           open={isModalOpen}
                           style={{minWidth: "720px"}}
                           onCancel={() => setIsModalOpen(false)}
                           footer={[
                               <Button key="submit" type="default" onClick={() => setIsModalOpen(false )}>
                                   Отменить
                               </Button>
                           ]}
                    >
                        <Line {...config} />
                    </Modal>
                    :
                    ""
            }
        </div>
    )
};

export default WorkingTime
